export const SMARTLINK_CONNECTION_TOUCHPOINTS = {
	onboarding: 'onboarding',
	sideNav: 'side-nav',
} as const;

export type SmartlinkConnectionTouchpoint =
	(typeof SMARTLINK_CONNECTION_TOUCHPOINTS)[keyof typeof SMARTLINK_CONNECTION_TOUCHPOINTS];
